import * as React from "react";
import * as BS from "react-bootstrap";
import { Icon, WrapperLess } from "../../../components/generic";
import * as M from "../../../models";

interface OwnProps {
    hideFilename?: boolean;
    media: M.Abstract.AbstractMedia;
}

interface OwnState {
}

export class MediaDisplay extends React.Component<OwnProps, OwnState> {
    public render() {
        const m = this.props.media;

        if (m.isImage && m.url)
            return <p>
                {m.thumbMd
                    ? <a href={m.url} target="_blank" title="Click to view larger image"><img alt={m.fileName} src={m.thumbMd} style={{ width: "500px" }} /></a>
                    : <img alt={m.fileName} src={m.url} style={{ width: "500px" }} />
                }
                {this.props.hideFilename ? null : <><br />{m.fileName}</>}
            </p>;
        else if (m.isVideo) {
            if (m.isProcessing) {
                return <BS.Alert bsStyle="info">
                    <Icon icon="check" /> Upload successful! Preview will be available after video is processed.
                </BS.Alert>;
            }
            else if (m.embedUrl)
                return <WrapperLess>
                    <video className="video" controls src={m.embedUrl} />
                    {this.props.hideFilename ? null : <p>{m.fileName}</p>}
                </WrapperLess>;
        }
        else if (m.url) {
            return <p>
                {m.thumbMd
                    ? <a href={m.url} target="_blank" title={m.fileName}><img alt={m.fileName} src={m.thumbMd} style={{ width: "500px" }} /></a>
                    : <a href={m.url}>{m.fileName}</a>}
                </p>;
        }

        return <p><em>None</em></p>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/abstracts/components/MediaDisplay.tsx